import React, { useContext, useEffect } from 'react';
import { Select, useTheme } from '@chakra-ui/react';
import { FaSortAmountDown } from 'react-icons/fa';
import { readableColor } from 'polished';
import { StoreContext } from '../../context/Store';
import { jsx as ___EmotionJSX } from "@emotion/react";
const Sort = _ref => {
  let {
    defaultSort
  } = _ref;
  const {
    sort,
    setSort
  } = useContext(StoreContext);
  const chakraTheme = useTheme();
  const sortOptions = [{
    label: 'Neuste zuerst',
    value: '-created_on'
  }, {
    label: 'Älteste zuerst',
    value: 'created_on'
  }, {
    label: 'Preis aufsteigend',
    value: 'price_brutto'
  }, {
    label: 'Preis absteigend',
    value: '-price_brutto'
  }, {
    label: 'Zufällig',
    value: '?'
  }];
  useEffect(() => {
    if (sort.length === 0) {
      setSort(defaultSort);
    }
    //eslint-disable-next-line
  }, [sort]);
  const onChangeSort = value => {
    setSort(value);
  };
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Select, {
    "aria-label": "Sortierung",
    defaultValue: defaultSort,
    onChange: e => onChangeSort(e.target.value),
    icon: ___EmotionJSX(FaSortAmountDown, null),
    color: readableColor(chakraTheme.colors.base['500']),
    sx: {
      color: readableColor(chakraTheme.colors.base['500'])
    }
  }, sortOptions.map(option => ___EmotionJSX("option", {
    key: option.value,
    value: option.value
  }, option.label))));
};
export default Sort;